import DefaultForgotPassword from '@spa/components/pages/auth/signup/shared/form-parts/components/default/DefaultForgotPassword.vue'
import LedianForgotPassword from '@spa/components/pages/auth/signup/shared/form-parts/components/ledian/LedianForgotPassword.vue'
import CartSignUpDefaultNote from '@spa/components/pages/cart/components/signup/default/DefaultNote.vue'
import Vue, { VueConstructor } from 'vue'

export interface SignUpPageParts {
  readonly note: VueConstructor
  readonly forgotPassword: VueConstructor
}

export const defaultSignUpPageParts: SignUpPageParts = {
  note: CartSignUpDefaultNote,
  forgotPassword: DefaultForgotPassword,
}

export const mycolorSignUpPageParts: SignUpPageParts = {
  note: CartSignUpDefaultNote,
  forgotPassword: DefaultForgotPassword,
}

export const vilbSignUpPageParts: SignUpPageParts = {
  note: CartSignUpDefaultNote,
  forgotPassword: DefaultForgotPassword,
}

export const fitowaSignupPageParts: SignUpPageParts = {
  note: CartSignUpDefaultNote,
  forgotPassword: DefaultForgotPassword,
}

export const ledianSignupPageParts: SignUpPageParts = {
  note: CartSignUpDefaultNote,
  forgotPassword: LedianForgotPassword,
}

export const loadingPageParts: SignUpPageParts = {
  note: Vue.extend({ template: '<div></div>' }),
  forgotPassword: Vue.extend({ template: '<div></div>' }),
}
